module.exports = __webpack_public_path__ + "img/main_img.60685938.png";